var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvestmentsGlobalPosition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-5026.000000, -1239.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Investments/Global-position",
    transform: "translate(5026.000000, 1239.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C7.163,0 0,7.164 0,16 C0,17.35 0.186,18.653 0.5,19.906 L5.906,14.918 L6.609,14.22 L12.233,19.829 L21.413,10.808 L18.223,10.608 C16.813,10.608 15.781,9.166 15.781,8 L25.991,8 L26.013,18.372 C24.603,18.372 23.48,17.325 23.48,15.919 L23.521,12.722 L12.233,24 L11.53,23.312 L10.346,22.137 L6.609,18.417 L1.754,23.259 C4.401,28.443 9.779,32 16,32 C24.837,32 32,24.836 32,16 C32,7.164 24.837,0 16,0",
    id: 21
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentsGlobalPosition);
export default __webpack_public_path__ + "static/media/investments-global-position.c0d16793.svg";
export { ForwardRef as ReactComponent };